export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;

/**
 * theme and locale
 */
export const defaultLocale = 'en';
export const localeOptions = [
  {id: 'en', name: 'English', direction: 'ltr'},
  {id: 'es', name: 'Español', direction: 'ltr'},
];
export const themeColorStorageKey = '__theme_selected_color';
export const defaultColor = 'light.blueolympic';
export const darkModeColor = 'dark.blueolympic';
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];

/**
 * URL variables
 */
export const adminRoot = '/app';
export const searchPath = `${adminRoot}/#`;
export const servicePath = 'https://www.kitu.io/';

// Message Variables
export const messageDismissTime = 4000; // time(ms) messages show before closing
export const errorDismissTime = 20000; // time(ms) errors show before closing
export const shortMessageDismissTime = 2000; // time(ms)messages show before closing
export const dismissTimes = {
  error: errorDismissTime,
  short: shortMessageDismissTime,
  success: messageDismissTime,
};

/**
 * TopNav options
 * - src > containers > navs
 */
export const isSearchActive = false;
export const isLocaleSwitchActive = false;
export const isDarkSwitchActive = false;
export const extraToggleOptionsActive = {
  isMainActive: true,
  isEasyAccessActive: false,
  isNotificationsActive: false,
  isFullScreenToggleActive: false,
};
export const extraPageOptions = {
  isFAQEnabled: false,
};

export const stationPollIntervalSeconds = 10;

export const receiptOptions = [
  {value: 'sms', label: 'Text'},
  {value: 'email', label: 'Email'},
  {value: 'all', label: 'Text and Email'},
];
